import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'

import { CloseButton } from '../../../../Modal'
import type { Images } from '../../imageType'
import styles from './Carousel.module.scss'
import type { ImageError } from './Carousel.utils'
import { handleError } from './Carousel.utils'
import type { SetPortalConfig } from './SlideImage'

export const CarouselPortal = ({
  setPortalConfig,
  zoomSrc,
  zoomSources,
  alt,
  portalZIndex,
}: CarouselPortalArgs) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return createPortal(
    <div
      data-testid="portal-container"
      className={styles.carouselPortalWrapper}
      {...(portalZIndex ? { style: { zIndex: portalZIndex } } : {})}
    >
      <TransformWrapper
        initialScale={1}
        minScale={1}
        centerOnInit={false}
        wheel={{ step: 0.1 }}
        doubleClick={{ mode: 'reset' }}
      >
        <TransformComponent>
          <img
            src={zoomSources?.large ?? zoomSrc}
            alt={alt}
            onError={(event: ImageError) => handleError(event, zoomSrc)}
          />
        </TransformComponent>
      </TransformWrapper>
      <CloseButton
        className={styles.closePortal}
        callback={() =>
          setPortalConfig((prev) => ({ ...prev, displayPortal: false }))
        }
      />
    </div>,
    document.body
  )
}

type CarouselPortalArgs = {
  setPortalConfig: SetPortalConfig
  zoomSrc?: Images['zoomSrc']
  zoomSources?: Images['zoomSources']
  alt?: Images['alt']
  portalZIndex?: number
}
